import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { getEndCustomerPrinted } from "API/swesum";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

import EndCustomerPrintedTable from "./components/EndCustomerPrintedTable";
import EndcustomerPrintedWorkflows from "./Workflows/EndcustomerPrintedWorkflows";

export function EndCustomerPrinted() {
  const navigate = useNavigate();

  const [printedInvoices, setPrintedInvoices] = useState([]);

  const asyncFetchPrintedInvoices = async () => {
    setPrintedInvoices(await getEndCustomerPrinted());
  };

  useEffect(() => {
    asyncFetchPrintedInvoices();
  }, []);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Fakturautskrifter</Typography>
              <Button
                onClick={() => navigate("create")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                SKAPA NY
              </Button>
            </Box>
            <EndCustomerPrintedTable
              printedInvoices={printedInvoices}
              fetchPrintedInvoices={asyncFetchPrintedInvoices}
            />
            <EndcustomerPrintedWorkflows />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
